import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  slideButtonNext: {
    id: 'seo_text_next_slide',
  },

  slideButtonPrev: {
    id: 'seo_text_previous_slide',
  },
});
